var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycleBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.505 17H1.804L1 5h10l-.807 12H6.505zM3.438 0h4.67v1.399h3.438v2.21H0v-2.21h3.438V0zm1.237 1.399H6.87v-.294H4.675v.294z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleBinIcon);
export default __webpack_public_path__ + "static/media/recycle-bin-icon.d57ea5b07210905121c3cd3c3bd804a7.svg";
export { ForwardRef as ReactComponent };